export default {"src":"/_next/static/image/public/images/ic_cart_grey.7c530c9093723fe611d03f587eba40b2.svg","height":23,"width":20};